import {
  Component,
  OnInit,
  OnDestroy,
  AfterContentInit,
  Input,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  HostListener,
  ContentChild,
  TemplateRef,
  AfterViewInit,
  OnChanges
} from '@angular/core';

import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { pagesToggleService } from '../../services/toggler.service';
import { AuthService, GetMeNotifiedService } from '@shared/services';
import { Router } from '@angular/router';

declare var pg: any;
@Component({
  selector: 'pg-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HorizontalMenuComponent
  implements OnInit, AfterViewInit, AfterContentInit, OnDestroy, OnChanges {
  menuItems = [];
  menus = [];
  _renduerMenuItemsLeft = [];
  _renduerMenuItemsRight = [];
  _hideExtra = 0;
  currentItem = null;
  _horizontalMobileMenu: boolean = false;
  resizeId: any;
  _service;
  //Simple hack flag to check if its wrapped
  _wrapped: boolean = false;
  @ViewChild('menuItemsList') _menuItemsList: ElementRef;
  @ViewChild('menuWrapper') _menuWrapper: ElementRef;
  @ContentChild('mobileSidebarFooter') mobileSidebarFooter: TemplateRef<void>;
  constructor(
    private toggler: pagesToggleService,
    private _authService: AuthService,
    private _getMeNotified: GetMeNotifiedService,
    private router: Router
  ) {
    this._service = this.toggler.mobileHorizontaMenu.subscribe(state => {
      this._horizontalMobileMenu = state;
      this.closeHorizontalMenu();
    });
  }

  @Input()
  set HideExtra(value) {
    this._hideExtra = value;
  }

  @Input()
  set Items(value) {
    this.menus = value;
    this.menuItems = this.menus['left'].concat(this.menus['right']);
    this._renduerMenuItemsLeft = this.menus['left'].slice();
    this._renduerMenuItemsRight = this.menus['right'].slice();
  }

  notifyModalOnSignUp(item) {
    if (item.iconComponentName === '') {
      this.getMeNotified(false);
    }
    this.router.navigate([item.routerLink]);
  }

  getMeNotified(isPreOrder) {
    this._getMeNotified.toggle();
    this._getMeNotified.setPreOrderStatus(isPreOrder);
  }

  ngOnInit() {}
  ngOnDestroy() {
    this._service.unsubscribe();
  }
  ngAfterContentInit(): void {}

  ngOnChanges(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (pg.isVisibleSm() || pg.isVisibleXs() || pg.isVisibleMd()) {
        return false;
      }
      this._onContentChanges();
    });
  }

  logout() {
    this._authService.logout();
    location.reload(true);
  }

  closeHorizontalMenu() {
    if (!this.currentItem) {
      return;
    }
    this.currentItem['open'] = false;
    this.currentItem['opening'] = false;
  }

  toggleLink(item) {
    // if (pg.isVisibleSm() || pg.isVisibleXs() || pg.isVisibleMd()) {
    if (window.innerWidth <= 991) {
      if (this.currentItem && this.currentItem !== item) {
        this.currentItem['mToggle'] = 'close';
      }
      if (this.currentItem === null) {
        this.currentItem = item;
        this.currentItem['mToggle'] = 'close';
      }
      this.currentItem = item;
      item.mToggle =
        !item.mToggle || item.mToggle === 'close' ? 'open' : 'close';
      return false;
    }
  }

  toggleLinkClick(event, item) {
    if (this.currentItem && this.currentItem != item) {
      this.currentItem['open'] = false;
      this.currentItem['opening'] = false;
    }
    this.currentItem = item;
    let elParent = event.currentTarget.parentNode;
    if (item['open']) {
      let el = elParent.querySelector('ul');
      let rect = el.getBoundingClientRect();
      item.ghost = {
        width: rect.width + 'px',
        height: 0,
        zIndex: 'auto'
      };
      item['open'] = false;
      setTimeout(() => {
        item['opening'] = false;
      }, 240);
    } else {
      item['open'] = true;
      setTimeout(() => {
        let el = elParent.querySelector('ul');
        let rect = el.getBoundingClientRect();
        item.ghost = {
          height: '0',
          width: rect.width + 'px',
          zIndex: 'auto'
        };
        item.ghost = {
          width: rect.width + 'px',
          height: rect.height + 'px',
          zIndex: 'auto'
        };

        setTimeout(() => {
          item['opening'] = true;
        }, 140);
      }, 0);
    }
  }

  toggleLinkOver(event, item) {
    //Desktop
    // if (!pg.isVisibleSm() && !pg.isVisibleXs()) {
    if (window.innerWidth > 991) {
      if (this.currentItem && this.currentItem !== item) {
        this.currentItem['open'] = false;
        this.currentItem['opening'] = false;
      }
      this.currentItem = item;
      const elParent = event.currentTarget.parentNode;
      if (!item['open']) {
        item['open'] = true;

        const el = elParent.querySelector('ul');
        const rect = el.getBoundingClientRect();

        item.ghost = {
          width: rect.width + 'px',
          height: rect.height + 'px',
          zIndex: 'auto'
        };
        item['opening'] = true;
      }
    }
  }

  toggleLinkOut(event, item) {
    //Desktop
    // if (!pg.isVisibleSm() && !pg.isVisibleXs()) {
    if (window.innerWidth > 991) {
      this.currentItem = item;
      const elParent = event.currentTarget.parentNode;
      if (item['open']) {
        const el = elParent.querySelector('ul');
        const rect = el.getBoundingClientRect();
        item.ghost = {
          width: rect.width + 'px',
          height: 0,
          zIndex: 'auto'
        };
        item['open'] = false;
        item['opening'] = false;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    clearTimeout(this.resizeId);
    this.resizeId = setTimeout(() => {
      if (pg.isVisibleSm() || pg.isVisibleXs()) {
        this._renduerMenuItemsLeft = this.menus['left'].slice();
        this._renduerMenuItemsRight = this.menus['right'].slice();
        return false;
      }
      this._onContentChanges();
    }, 140);
  }

  _onContentChanges() {
    this._renduerMenuItemsLeft = this.menus['left'].slice();
    this._renduerMenuItemsRight = this.menus['right'].slice();
  }
  toggleHorizontalMenu() {
    if (this._horizontalMobileMenu) {
      this._horizontalMobileMenu = false;
    } else {
      this._horizontalMobileMenu = true;
    }
    this.toggler.toggleMobileHorizontalMenu(this._horizontalMobileMenu);
  }
}
